import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import AppLoading from "../app-loading/app-loading";
import { Toast } from "primereact/toast";
import PosSearch from "./Pos-search";
import { POSProductModel } from "../../models/all-user/edit-user-model";
import PosListDatatable from "./pos-list-datatable";
import posService from "../../services/pos/pos.service";

const Positems = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [filteredProducts, setFilteredProducts] = useState<POSProductModel[]>([]);
  const [productList, setProductList] = useState<POSProductModel[]>([]);
  const [loading, setLoading] = useState(false);
  const [activeStatusFilters, setActiveStatusFilters] = useState<string[]>([]);
  const [keywordsearch, setKeywordsearch] = useState<string>("");
  const [posIdS, setPosId] = useState<number[]>([]);

  const getAllProducts = (posId: any) => {
    posId.length === 0 && setActiveStatusFilters([]);
    posService.posproducts(posId).then((response) => {
      setProductList(response);
      var statusFilteredProducts = response;
      if (activeStatusFilters.length > 0) {
         statusFilteredProducts = statusFilteredProducts.filter((product: any) => activeStatusFilters.includes(product.status));
      }
      if (keywordsearch && keywordsearch.trim() !== "") {
        statusFilteredProducts = statusFilteredProducts.filter(
          (product: any) =>  product.productName.toLowerCase().includes(keywordsearch.toLowerCase())
        );
      }
      activeStatusFilters.length > 0 ||  keywordsearch.trim() !== ""? setFilteredProducts(statusFilteredProducts) : setFilteredProducts(response);
      setLoading(false);
    });
  }
  

  function handleSearch(query: string): void {
    setLoading(true);
    setKeywordsearch(query);
    if (productList && productList.length > 0) {
      const searchedProducts = productList.filter(
        (product) =>
          product.productName &&
          typeof product.productName === "string" &&
          product.productName.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredProducts(searchedProducts);
    } else {
      setFilteredProducts([]);
    }
    setTimeout(() => setLoading(false), 200);
  }

  const handlePOSChange = (posId: any) => {
    setLoading(true);
    setPosId(posId);
    //const posIdArray= {...posId};
    getAllProducts(posId);
  };

  const handleAddSuccess = (posId: number[]) => {
    getAllProducts(posIdS); // refresh after adding
  };

  // called by PosSearch when status checkboxes change
  const handleStatusChange = (statuses: string[]) => {
    const filteredStatus = productList.filter(product => statuses.includes(product.status));
    statuses.length > 0 ? setFilteredProducts(filteredStatus) : setFilteredProducts(productList);
    setActiveStatusFilters(statuses);
  };

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-right" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <h5 className="ml-1 mb-0">{t("POS Inventory Master")}</h5>
          </div>
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <PosSearch onSearch={handleSearch} setLoading={setLoading} onPOSChange={handlePOSChange} onAddSuccess={handleAddSuccess} onStatusFilterChange={handleStatusChange} />
            </div>
          </div >
          <PosListDatatable data={filteredProducts} onRefresh={handleAddSuccess} setLoading={setLoading}   selectedPosIds={posIdS} />
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default Positems;
